import { Button, ButtonProps, message } from "antd";
import { FC, useState } from "react";
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import SavedMessage from "../../../../components/messages/savedMessage";
import LeasingStore from "../../../../contexts/leasingStore";
import _t from "../../../../lang/translate";
import { toggleInputLock } from "../../../../services/leasingService";
import Icon from "../../../../assets/icons/icon";

const LockCaseButton: FC<ButtonProps> = (props) => {
  const { leasingCase, setLeasingCase } = LeasingStore.useContainer();
  const [loading, setLoading] = useState<boolean>(false);
  const { id, flags } = leasingCase;

  const { inputLocked } = flags;

  const handleLockClick = async () => {
    try {
      setLoading(true);
      await toggleInputLock(id, !inputLocked);
      message.success(<SavedMessage />);
      setLeasingCase({ ...leasingCase, flags: { ...leasingCase.flags, inputLocked: !inputLocked } });
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button {...props} loading={loading} onClick={handleLockClick}
      icon={<Icon name={inputLocked ? "lock-open-outline" : "lock-closed-outline"} />}
    >
      {_t(inputLocked ? "unlock_case" : "lock_case")}
    </Button>
  );
};

export default LockCaseButton;
